module.exports = __webpack_public_path__ + "img/var_03_step2@2x.3d0ed428.jpg";